import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { modalEventListenerAllowXScroll } from "../utils/ModalEventListener";
import { axios_instance, updateAxiosHeaders } from "../api/axios_instance";
import { encryptRequest } from "../utils/encryptdecryptrequest";
import { toast } from "react-toastify";
import { CSSTransition } from "react-transition-group";

const NavigationModal = ({ closeNavigationModal, showNavigationModal }) => {
  const ref = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    return modalEventListenerAllowXScroll(ref, closeNavigationModal);
  }, [closeNavigationModal]);

  const user = useSelector((state) => state.user);
  const availableStatus = user.activity_status;
  const today = new Date();

  const signOut = async (e) => {
    e.preventDefault();
    const reqBody = encryptRequest({ activity_status: 0 });
    toast.dismiss();
    try {
      const result = await axios_instance({
        url: "/trackUserActivity",
        method: "POST",
        data: { reqBody },
      });
      if (result.status === 200) {
        dispatch({ type: "remove_user" });

        updateAxiosHeaders();
      }
    } catch (error) {
      toast.error(
        error?.response?.data.message
          ? error.response.data.message
          : "Something went wrong",
        { theme: "colored" }
      );
    } finally {
      localStorage.clear();
      sessionStorage.clear();

      navigate("/");
    }
  };

  const handleAvailabilityIconsClick = async (e, changedStatus) => {
    e.preventDefault();
    const prevStatus = availableStatus;
    if (prevStatus !== changedStatus) {
      const reqBody = encryptRequest({ activity_status: changedStatus });
      try {
        const result = await axios_instance({
          url: "/trackUserActivity",
          method: "POST",
          data: { reqBody },
        });
        if (result.status === 200) {
          dispatch({ type: "change_user", payload: changedStatus });
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast.dismiss();
          toast.error(error.response.data.message, { theme: "colored" });
        }
      }
    }
  };

  return ReactDOM.createPortal(
    <CSSTransition
      in={showNavigationModal}
      timeout={300}
      classNames="side-menu"
      unmountOnExit
      nodeRef={ref}
    >
      <div className="modal-wrapper">
        <div className="side-menu" ref={ref}>
          <button
            type="button"
            className="close nav-box-close"
            onClick={closeNavigationModal}
            ref={ref}
          >
            <img
              src={`${process.env.REACT_APP_STYLES_PATH}ic-close.png`}
              alt="close"
            />
          </button>{" "}
          <div className="nav-wrapper ">
            <div>
              <nav className="navbar navbar-inverse sidenav" role="navigation">
                <div className="user_profile" id="profile_box">
                  <div className="my-profile-img">
                    <img
                      src={`${process.env.REACT_APP_STYLES_PATH}profile.jpg`}
                      alt=""
                    />
                    <div className="upload-profile-pic">
                      <span
                        className="fa fa-camera font-16"
                        aria-hidden="true"
                      ></span>
                    </div>
                  </div>

                  <div className="my-profile-detail">
                    <ul className="my-profile-title">
                      <li>
                        <h3 className="hd-txt usr-txt">{user.role}</h3>
                      </li>
                      <li>
                        <span className="hd-txt">Welcome</span> {user.name}
                      </li>
                    </ul>
                  </div>
                  <div className="clearfix"></div>
                  <div className="row">
                    <ul className="user_availability_btn">
                      {user?.menuVisibilityObj?.showAvailabilityIcons ? (
                        <>
                          <li>
                            <Link
                              id="link"
                              to=""
                              className={`availability-icons available-icon ${
                                availableStatus === 1 ? "active" : ""
                              }`}
                              onClick={(e) =>
                                handleAvailabilityIconsClick(e, 1)
                              }
                            >
                              <span
                                className="fa fa-circle"
                                aria-hidden="true"
                              ></span>
                              <span className="nav-actions">Available</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              id="link"
                              to=""
                              className={`availability-icons away-icon ${
                                availableStatus === 2 ? "active" : ""
                              }`}
                              onClick={(e) =>
                                handleAvailabilityIconsClick(e, 2)
                              }
                            >
                              <span
                                className="fa fa-circle"
                                aria-hidden="true"
                              ></span>
                              <span className="nav-actions">Away</span>
                            </Link>
                          </li>
                        </>
                      ) : (
                        ""
                      )}
                      <li>
                        <a
                          id="link"
                          href={{ javascript: void 0 }}
                          className="availability-icons sign-out"
                          onClick={signOut}
                          style={{ margin: "0" }}
                        >
                          <span
                            className="glyphicon glyphicon-off nav-actions"
                            aria-hidden="true"
                          ></span>{" "}
                          <span className="nav-actions">Sign Out</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="side-menu-container clearfix">
                  <ul className="nav navbar-nav" id="leftpanellist">
                    {user?.menuVisibilityObj?.panelVisibilityObj
                      ?.showListingPanel ? (
                      <li className="active">
                        <Link id="link" to="/payments/disbursement_list">
                          <div className="link_container">
                            <span
                              className="fa fa-bars"
                              aria-hidden="true"
                            ></span>
                            <span className="hd-txt">PAYMENTS</span>
                          </div>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {user?.menuVisibilityObj?.panelVisibilityObj
                      ?.showWithheldPanel ? (
                      <li className="">
                        <Link id="link" to="/payments/withheld_maker_list">
                          <div className="link_container">
                            <span
                              className="fa fa-bars"
                              aria-hidden="true"
                            ></span>
                            <span className="hd-txt">Withheld Panel</span>
                          </div>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {user?.menuVisibilityObj?.panelVisibilityObj
                      ?.showBulkBankPaymentPanel ? (
                      <li className="">
                        <Link id="link" to="/payments/bank_payment_panel">
                          <div className="link_container">
                            <span
                              className="fa fa-bars"
                              aria-hidden="true"
                            ></span>
                            <span className="hd-txt">
                              Bank Payment Bulk Update
                            </span>
                          </div>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {user?.menuVisibilityObj?.panelVisibilityObj
                      ?.showBankBoxPanel ? (
                      <li className="">
                        <Link id="link" to="/payments/bank_box_panel">
                          <div className="link_container">
                            <span
                              className="fa fa-bars"
                              aria-hidden="true"
                            ></span>{" "}
                            <span className="hd-txt">Bank Box Panel</span>
                          </div>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {user?.menuVisibilityObj?.panelVisibilityObj
                      ?.showBankBoxFlagPanel ? (
                      <li className="">
                        <Link id="link" to="/payments/bank_box_flag_config">
                          <div className="link_container">
                            <span
                              className="fa fa-bars"
                              aria-hidden="true"
                            ></span>
                            <span className="hd-txt">Bank Box Flags</span>
                          </div>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {user?.menuVisibilityObj?.panelVisibilityObj
                      ?.showPaymentAdminPanel ? (
                      <li className="">
                        <Link id="link" to="/payments/payments_admin_panel">
                          <div className="link_container">
                            <span
                              className="fa fa-bars"
                              aria-hidden="true"
                            ></span>
                            <span className="hd-txt">Payments Admin Panel</span>
                          </div>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {user?.menuVisibilityObj?.panelVisibilityObj
                      ?.showEnvConfigPanel ? (
                      <li className="">
                        <Link id="link" to="/payments/manage_env_config">
                          <div className="link_container">
                            <span
                              className="fa fa-bars"
                              aria-hidden="true"
                            ></span>
                            <span className="hd-txt">Manage Env Config</span>
                          </div>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}

                    {user?.menuVisibilityObj?.panelVisibilityObj
                      ?.showResourcePanel ? (
                      <li className="">
                        <Link id="link" to="/payments/resource_panel">
                          <div className="link_container">
                            <span
                              className="fa fa-bars"
                              aria-hidden="true"
                            ></span>
                            <span className="hd-txt">Resources Panel</span>
                          </div>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {user?.menuVisibilityObj?.panelVisibilityObj
                      ?.showCronsPanel ? (
                      <li className="">
                        <Link id="link" to="/payments/crons_panel">
                          <div className="link_container">
                            <span
                              className="fa fa-bars"
                              aria-hidden="true"
                            ></span>
                            <span className="hd-txt">Crons Panel</span>
                          </div>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                  </ul>
                </div>
                <div className="footer_box">
                  <div className="clearfix"></div>
                  <hr className="sidebar" />
                  <div className="rcside_box">
                    <div className="rcside_txt">Email</div>
                    <h3 className="help-mail">TO: support@rupyy.com</h3>
                    <h3 className="help-mail">CC: ucl.product@rupyy.com</h3>
                  </div>
                  <div className="clearfix"></div>
                  <hr className="sidebar" />
                  <div className="rcside_box">
                    <div className="rcside_txt">
                      © {today.getFullYear()} gaadi.com | All rights reserved
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </CSSTransition>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default NavigationModal;
